import { Component } from '@angular/core';
import { CalculationModelService } from 'src/app/modules/app-settings/services/calculation-model-service';
import { AdminTabs } from '../../enum';
import { NavigationService } from '../../navigation.service';

/**
 * Calc model (template) navigation
 */
@Component({
  selector: 'calculation-model-navigation',
  templateUrl: './calculation-model-navigation.component.html'
})
export class CalculationModelNavigationComponent {
  /**
   * Search active flag.
   */
  searchActive = false;

  /**
   * Constructor
   * @param navigationService NavigationService
   * @param cmService CalculationModelService
   */
  constructor(private navigationService: NavigationService, public cmService: CalculationModelService) { }

  /**
   * Sets the active tab
   * @param tab The active tab
   */
  setActiveTab(tab: AdminTabs) {
    this.navigationService.setActiveAdminTab(tab);
  }

  /**
   * Gets the AdminTabs enum
   */
  public get AdminTab(): typeof AdminTabs {
    return AdminTabs;
  }

  /**
   * Triggers the archive action
   */
  archive() {
    this.cmService.triggerArchive();
  }

  /**
   * Triggers the edit action
   */
  edit() {
    this.cmService.triggerEditMode();
  }

  /**
   * Triggers the search action
   */
  search() {
    this.searchActive = !this.searchActive;
    this.cmService.setSearchActive(this.searchActive);
  }

  /**
   * Triggers the reset search action
   */
  resetSearch() {
    this.cmService.triggerResetSearch();
  }
}
